import PropTypes from "prop-types";
import React from "react";

function NavLoader(props) {
  const { children, className, isLoading } = props;
  const wrapperClass = `nav-loader ${className}`;

  if (!isLoading) {
    return <div className={wrapperClass} />;
  }

  return (
    <div className={`${wrapperClass} nav-loader-padding`}>
      <div className="spinner spin" />
      <div className="spinner-label">
        {children === null ? "Loading..." : children}
      </div>
    </div>
  );
}

NavLoader.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
};

NavLoader.defaultProps = {
  children: null,
  className: "",
  isLoading: false,
};

export { NavLoader };
